import { useEffect } from "react";
import { useParams } from "react-router";

import { Box, CircularProgress, Stack, Typography } from "@mui/material";

import { useCaseNoteLabel } from "@/common/hooks/useCaseNoteLabel";
import { CaseNoteContent } from "@/pages/clients/client/components/tabs/notes-tab/components/case-note-content/CaseNoteContent";
import { useTranslation } from "@/translations";

import { useCaseNotePopout } from "./hooks/useCaseNotePopout";

export function CaseNotePopout() {
  const { t } = useTranslation();
  const { id: clientId, noteId } = useParams();
  const { caseNote, isLoading } = useCaseNotePopout(clientId, noteId);
  const caseNoteLabel = useCaseNoteLabel(caseNote);

  useEffect(() => {
    document.title = caseNoteLabel || document.title;
  }, [caseNoteLabel]);

  return (
    <Stack height={"100vh"} bgcolor={"background.default"} p={2} overflow={"auto"}>
      {isLoading ? (
        <Box display={"flex"} flex={1} justifyContent={"center"} alignItems={"center"}>
          <CircularProgress />
        </Box>
      ) : caseNote && clientId ? (
        <CaseNoteContent clientId={clientId} caseNote={caseNote} />
      ) : (
        <Typography>{t("clients.client.caseNotes.popoutNotFound")}</Typography>
      )}
    </Stack>
  );
}
